import React from 'react'
import PropTypes from 'prop-types'

export default class Tooltip extends React.Component {
  timer = false
  _mounted = false
  state = { visible: false }

  static propTypes = {
    children: PropTypes.any.isRequired,
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    theme: PropTypes.object.isRequired,
  }

  state = {
    visible: false,
  }
  timer = false

  toggle = visible => {
    // Debounce mouse hover
    if (this.timer) {
      clearTimeout(this.timer)
    }
    this.timer = setTimeout(() => {
      if (this.state.visible !== visible) this.setVisibility(visible)
    }, 10)
  }

  setVisibility = visible => {
    if (this._mounted) {
      this.setState({ visible })
    }
  }

  componentWillMount() {
    this._mounted = true
  }

  componentWillUnmount() {
    this._mounted = false
  }

  capitalize(s) {
    return s[0].toUpperCase() + s.toLowerCase().slice(1)
  }

  render() {
    const { props: { theme, children, content }, state, toggle } = this
    return (
      <div
        onMouseEnter={() => toggle(true)}
        onMouseLeave={() => toggle(false)}
        onClick={() => toggle(false)}
        className={theme['tooltip-wrapper']}
      >
        {children}
        <If condition={state.visible}>
          <div className={theme.tooltip}>
            <div className={theme['tooltip-content']}>{this.capitalize(content)}</div>
            <div className={theme['tooltip-arrow']}> </div>
            <div className={theme['tooltip-gap']}> </div>
          </div>
        </If>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./ui/Tooltip/Tooltip.js